class DressthingKeymapTool extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    const host = this;
    const doc = this.ownerDocument;
    const root = this.attachShadow({ mode: 'open' });
    root.innerHTML = `
      <style>
        :host{display:block;color:#20251f;font-family:-apple-system,BlinkMacSystemFont,"Hiragino Kaku Gothic ProN","Hiragino Sans","Noto Sans JP",sans-serif;font-size:15px;line-height:1.9;letter-spacing:.01em;--paper:#fff;--ground:#f5f4f0;--ink:#20251f;--mut:#6e706c;--faint:#9a9c97;--line:#e5e4e0;--field:#edebe6;--band:#e3e1da;--serif:"Shippori Mincho B1","Hiragino Mincho ProN","Yu Mincho",serif}
        *{box-sizing:border-box}.tool{display:block}.connect-panel{display:grid;grid-template-columns:minmax(240px,.7fr) minmax(260px,1fr);gap:26px;align-items:center;background:var(--ground);padding:28px;margin-bottom:48px}
        .connect-button,.save-button{appearance:none;border:1px solid var(--ink);background:var(--ink);color:var(--paper);min-height:52px;padding:0 24px;font:inherit;font-size:14px;font-weight:600;cursor:pointer}.connect-button:disabled{opacity:.45;cursor:not-allowed}
        .connect-copy{min-width:0}.connect-note{margin:0;color:var(--mut);font-size:12px;line-height:1.75}.status{min-height:1.7em;margin:8px 0 0;font-size:13px;font-weight:600}.status[data-tone="error"]{color:#9a3549}.status[data-tone="success"]{color:#2f6552}
        .map-card{border-top:1px solid var(--ink);padding-top:20px}.map-head{display:flex;align-items:center;justify-content:space-between;gap:16px}.map-head h2{font:600 11px/1.4 inherit;letter-spacing:.24em;margin:0}.source-badge{font-size:12px;color:var(--mut)}
        .switch{display:flex;flex-wrap:wrap;gap:1px;background:var(--line);border:1px solid var(--line);margin:24px 0 0}.switch button{flex:1 1 auto;min-width:5.2em;background:var(--paper);border:0;padding:10px 8px;cursor:pointer;font:inherit;font-size:13px;font-weight:600;letter-spacing:.02em;color:var(--ink);display:flex;flex-direction:column;gap:1px;align-items:center;line-height:1.35}.switch button i{font-style:normal;font-size:10px;font-weight:400;color:var(--mut);letter-spacing:.06em}.switch button[aria-selected="true"]{background:var(--ink);color:var(--paper)}.switch button[aria-selected="true"] i{color:rgba(255,255,255,.62)}#tabs button:nth-child(2)[aria-selected="true"]{background:#e34b4f}#tabs button:nth-child(3)[aria-selected="true"]{background:#2f63d3}#tabs button:nth-child(4)[aria-selected="true"]{background:#078a72}#tabs button:nth-child(5)[aria-selected="true"]{background:#6e706c}.switch.boards button{min-width:8em}.switch[hidden]{display:none}.map-switch-note{margin:22px 0 10px;font-size:13px;line-height:1.7;color:var(--mut)}
        .board{container-type:inline-size;margin:20px 0 0}.keys{position:relative}.k{--layer-accent:#20251f;--hold-color:#20251f;position:absolute;border:1px solid #cbc9c2;border-radius:clamp(4px,1.1cqw,9px);background:#f7f6f2;display:flex;align-items:center;justify-content:center;text-align:center;line-height:1.15;overflow:hidden}.k .m{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:0 2px;color:var(--layer-accent);font-size:max(8px,var(--key-font,1.6cqw));font-weight:700;letter-spacing:-.01em}.k.dual .m{transform:translateY(-10%)}.k.len3 .m{font-size:max(7px,var(--key-font-len3,1.35cqw))}.k.len5 .m{font-size:max(6px,var(--key-font-len5,1.1cqw));line-height:1.05;text-wrap:balance}.k.len7 .m{font-size:max(5px,var(--key-font-len7,.9cqw));line-height:1.05;text-wrap:balance}.k .h{position:absolute;left:50%;bottom:6%;transform:translateX(-50%);max-width:88%;border-radius:999px;background:var(--hold-color);color:#fff;font-size:max(6px,var(--hold-font,1.4cqw));font-weight:700;line-height:1.2;letter-spacing:-.02em;padding:.16em .7em .2em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.k.gate{background:#f7f6f2}.k.trns,.k.empty{background:#f7f6f2;border-color:#cbc9c2}.k.trns .m,.k.empty .m{color:var(--faint);font-weight:400}.k.q{background:repeating-linear-gradient(-45deg,#f7f6f2 0 5px,#edebe6 5px 10px)}.k.enc{background:#f7f6f2;border-color:var(--ink);border-radius:50%}.k.enc .m{display:grid;grid-template-columns:1fr 1fr;align-items:stretch;padding:15% 8%;color:var(--ink);letter-spacing:0}.k.enc .encoder-side{min-width:0;display:flex;align-items:center;justify-content:center}.k.enc .encoder-side b{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis;font-size:clamp(10px,var(--dial-font,1.6cqw),18px);font-weight:700;line-height:1;color:var(--layer-accent);white-space:nowrap}.k.enc .encoder-side b.medium{font-size:clamp(9px,var(--dial-font-medium,1.15cqw),13px)}.k.enc .encoder-side b.long{font-size:clamp(8px,var(--dial-font-long,.9cqw),10px)}
        .legend{display:flex;flex-wrap:wrap;gap:14px 22px;margin:20px 0 0;font-size:clamp(11px,.9vw,14px);color:var(--mut);align-items:center}.legend span{display:flex;align-items:center;gap:7px}.legend i{width:26px;height:26px;border:1px solid #cbc9c2;border-radius:4px;background:#f7f6f2;flex:0 0 auto;position:relative}.legend i::after{content:"";position:absolute;left:50%;bottom:3px;width:70%;height:7px;transform:translateX(-50%);border-radius:999px;background:var(--ink)}.legend i.plain::after{display:none}.legend i.trns::after{display:none}.legend i.none::after{display:none}.legend i.enc{border-color:var(--ink);border-radius:50%;background:#f7f6f2}.legend i.enc::after{display:none}
        .export-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:0 32px;margin-top:30px;padding-top:22px;border-top:1px solid var(--line)}.download-option{appearance:none;width:100%;min-height:76px;padding:15px 0;border:0;border-bottom:1px solid var(--ink);background:transparent;color:var(--ink);display:grid;grid-template-columns:minmax(0,1fr) auto;gap:18px;align-items:center;text-align:left;cursor:pointer;font:inherit}.download-option strong{display:block;font-size:14px;font-weight:600;line-height:1.45}.download-option small{display:block;margin-top:3px;color:var(--mut);font-size:11px;font-weight:400;line-height:1.55}.download-option__file{font-size:11px;font-weight:600;letter-spacing:.08em;white-space:nowrap}.privacy{margin:44px 0 0;padding:22px 0 0;border-top:1px solid var(--line);display:grid;grid-template-columns:150px 1fr;gap:28px}.privacy h3{font:600 13px/1.5 inherit;letter-spacing:.08em;margin:0}.privacy p{margin:0;color:var(--mut);font-size:13px;max-width:58em}
        @media(max-width:749px){.connect-panel{grid-template-columns:1fr;gap:16px;padding:22px 20px;margin-bottom:38px}.export-actions{grid-template-columns:1fr;gap:0}.privacy{grid-template-columns:1fr;gap:8px}.legend{gap:10px 16px}}
      </style>
      <div class="tool">
        <section class="connect-panel">
          <button class="connect-button" id="connectButton" type="button">DRESSTHINGから読み取る</button>
          <div class="connect-copy"><p class="connect-note" id="supportNote">ChromeまたはEdgeのデスクトップ版で利用できます。</p><p class="status" id="status" aria-live="polite">標準キーマップを表示しています。</p></div>
        </section>
        <section class="map-card" aria-labelledby="mapTitle">
          <div class="map-head"><h2 id="mapTitle">KEYMAP</h2><span class="source-badge" id="sourceBadge">標準キーマップ</span></div>
          <div class="switch boards" id="boards" role="tablist"></div>
          <p class="map-switch-note">レイヤー名をタップすると、下のキーマップが切り替わります。</p>
          <div class="switch" id="tabs" role="tablist"></div>
          <div class="board"><div class="keys" id="keys"></div></div>
          <div class="legend"><span><i></i>カプセル＝長押し</span><span><i class="plain"></i>タップだけ</span><span><i class="trns"></i>ベースと同じ</span><span><i class="none"></i>割り当てなし</span><span><i class="enc"></i>ダイヤル</span></div>
          <div class="export-actions" aria-label="チートシートをダウンロード"><button class="download-option" id="saveCompositePngButton" type="button"><span><strong>1枚版</strong><small>L0〜L4をひとつのキーマップにまとめます</small></span><span class="download-option__file">PNG ↓</span></button><button class="download-option" id="savePngButton" type="button"><span><strong>レイヤー別</strong><small>各レイヤーの配置を分けて一覧にします</small></span><span class="download-option__file">PNG ↓</span></button></div>
        </section>
        <section class="privacy"><h3>読み取り専用</h3><p>キーマップはこのブラウザ内だけで処理され、サーバーへ送信されません。本体への書き込みや設定変更は行いません。iPhone／iPadなどWebHIDに対応していない端末では、標準キーマップの表示と画像のダウンロードのみ利用できます。</p></section>
      </div>`;

    try {
      const DATA = await fetch(host.dataset.defaultUrl).then((response) => {
        if (!response.ok) throw new Error('標準キーマップを読み込めませんでした。');
        return response.json();
      });
      const NAMES = Array.from(
        { length: Math.max(...Object.values(DATA).map((board) => board.layers.length)) },
        (_, index) => 'Layer ' + index,
      );
      const boardsEl = root.getElementById('boards');
      const tabsEl = root.getElementById('tabs');
      const keysEl = root.getElementById('keys');
      const names = Object.keys(DATA);
      const LAYER_COLORS = ['#20251f', '#e34b4f', '#2f63d3', '#078a72', '#6e706c'];
      const COMPACT_LABELS = {'カーソル↑':'M↑','カーソル↓':'M↓','カーソル←':'M←','カーソル→':'M→','左クリック':'M1','右クリック':'M2','中クリック':'M3','ホイール↑':'W↑','ホイール↓':'W↓','ホイール←':'W←','ホイール→':'W→','右Shift':'RShift','無線で出力':'無線出力','USBで出力':'USB出力','新規ペアリング':'ペアリング','0番に接続':'接続 0','1番に接続':'接続 1','2番に接続':'接続 2','全部を削除':'全削除'};
      let bi = 0;
      let li = 0;
      const esc = (value) => String(value).replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]);
      const caption = (cell) => {
        if (cell.jump !== null || !cell.hold || cell.hold.only) return null;
        return cell.hold.kind === 'layer' ? 'L' + cell.hold.L : (COMPACT_LABELS[cell.hold.t] || cell.hold.t);
      };
      const mainLabel = (cell) => {
        if (cell.jump !== null) return 'L' + cell.jump;
        if (cell.hold && cell.hold.only) return 'L' + cell.hold.L;
        return COMPACT_LABELS[cell.m] || cell.m;
      };
      const dialAssignments = (data, layer) => {
        if (data.encoderReadable === false) return { clockwise: '?', counterClockwise: '?' };
        let turns = data.encoders[layer];
        let source = layer;
        while (turns && turns[0] && turns[0].raw === '0x0001' && source > 0) { source -= 1; turns = data.encoders[source]; }
        const turn = (item) => !item || item.raw === '0x0000' ? '—' : item.jump !== null ? 'L' + item.jump : (COMPACT_LABELS[item.m] || item.m || '—');
        const clockwise = turn(turns && turns[0]);
        const counterClockwise = turn(turns && turns[1]);
        return { clockwise, counterClockwise };
      };
      const draw = () => {
        const data = DATA[names[bi]];
        const cells = data.layers[li];
        [...boardsEl.children].forEach((button, index) => button.setAttribute('aria-selected', index === bi));
        [...tabsEl.children].forEach((button, index) => button.setAttribute('aria-selected', index === li));
        const maxX = Math.max(...cells.map((cell) => cell.x)) + 1;
        const maxY = Math.max(...cells.map((cell) => cell.y)) + 1;
        keysEl.style.setProperty('--pitch', 'calc(100cqw / ' + maxX + ')');
        keysEl.style.setProperty('--key-font', (16 / maxX) + 'cqw');
        keysEl.style.setProperty('--key-font-len3', (13.5 / maxX) + 'cqw');
        keysEl.style.setProperty('--key-font-len5', (11 / maxX) + 'cqw');
        keysEl.style.setProperty('--key-font-len7', (9 / maxX) + 'cqw');
        keysEl.style.setProperty('--hold-font', (14 / maxX) + 'cqw');
        keysEl.style.setProperty('--encoder-font', (22 / maxX) + 'cqw');
        keysEl.style.setProperty('--dial-font', (16 / maxX) + 'cqw');
        keysEl.style.setProperty('--dial-font-medium', (11.5 / maxX) + 'cqw');
        keysEl.style.setProperty('--dial-font-long', (9 / maxX) + 'cqw');
        keysEl.style.height = 'calc(' + maxY + ' * var(--pitch))';
        keysEl.innerHTML = '';
        const dial = dialAssignments(data, li);
        cells.forEach((cell, index) => {
          const isEncoder = data.enc.includes(index);
          const cap = isEncoder ? null : caption(cell);
          const label = isEncoder ? '' : mainLabel(cell);
          const length = (label || '').length;
          const element = doc.createElement('div');
          element.className = 'k' + (isEncoder ? ' enc' : '') + (cell.q ? ' q' : '') + (cell.raw === '0x0001' ? ' trns' : '') + (!isEncoder && cell.raw === '0x0000' ? ' empty' : '') + (cap ? ' dual' : '') + (length >= 7 ? ' len7' : length >= 5 ? ' len5' : length >= 3 ? ' len3' : '');
          element.style.left = 'calc(' + cell.x + ' * var(--pitch))';
          element.style.top = 'calc(' + cell.y + ' * var(--pitch))';
          element.style.width = 'calc(var(--pitch) - 7px)';
          element.style.height = 'calc(var(--pitch) - 7px)';
          element.style.setProperty('--layer-accent', LAYER_COLORS[li] || LAYER_COLORS[0]);
          const holdColor = cell.hold && cell.hold.kind === 'layer' ? LAYER_COLORS[cell.hold.L] : LAYER_COLORS[0];
          element.style.setProperty('--hold-color', holdColor || LAYER_COLORS[0]);
          element.title = isEncoder ? '左回転: ' + dial.counterClockwise + '／右回転: ' + dial.clockwise : cell.raw + (cell.note ? '　' + cell.note : '');
          const dialSizeClass = (value) => String(value).length >= 5 ? 'long' : String(value).length >= 3 ? 'medium' : '';
          element.innerHTML = isEncoder ? '<span class="m encoder-map"><span class="encoder-side"><b class="' + dialSizeClass(dial.counterClockwise) + '">' + esc(dial.counterClockwise) + '</b></span><span class="encoder-side"><b class="' + dialSizeClass(dial.clockwise) + '">' + esc(dial.clockwise) + '</b></span></span>' : '<span class="m">' + (esc(label) || '&nbsp;') + '</span>' + (cap ? '<span class="h">' + esc(cap) + '</span>' : '');
          keysEl.appendChild(element);
        });
      };
      names.forEach((name, index) => {
        const button = doc.createElement('button');
        button.type = 'button';
        button.innerHTML = esc(name) + '<i>' + esc(DATA[name].name) + '</i>';
        button.onclick = () => { bi = index; li = 0; draw(); };
        boardsEl.appendChild(button);
      });
      NAMES.forEach((name, index) => {
        const button = doc.createElement('button');
        button.type = 'button';
        button.textContent = name;
        button.onclick = () => { li = index; draw(); };
        tabsEl.appendChild(button);
      });
      draw();


  const VENDOR_ID = 0xedb8;
  const DEVICES = {
    0xd355: { board: 'solo / fold', file: host.dataset.soloUrl },
    0x2235: { board: 'twins', file: host.dataset.twinsUrl },
  };
  const REPORT_LENGTH = 32;
  const BUFFER_CHUNK = 28;
  const MAX_LAYERS = 5;
  const COMPOSITE_LAYER_COUNT = 5;

  const connectButton = root.getElementById('connectButton');
  const supportNote = root.getElementById('supportNote');
  const status = root.getElementById('status');
  const sourceBadge = root.getElementById('sourceBadge');
  const savePngButton = root.getElementById('savePngButton');
  const saveCompositePngButton = root.getElementById('saveCompositePngButton');

  const BASIC = {
    0x00: '', 0x01: '', 0x28: 'Enter', 0x29: 'Esc', 0x2a: 'BSpc',
    0x2b: 'Tab', 0x2c: 'Space', 0x2d: '-', 0x2e: '=', 0x2f: '[',
    0x30: ']', 0x31: '\\', 0x33: ';', 0x34: "'", 0x35: '`',
    0x36: ',', 0x37: '.', 0x38: '/', 0x39: 'Caps', 0x4a: 'Home',
    0x4b: 'PgUp', 0x4c: 'Del', 0x4d: 'End', 0x4e: 'PgDn',
    0x4f: '→', 0x50: '←', 0x51: '↓', 0x52: '↑',
    0x54: '/', 0x55: '*', 0x56: '−', 0x57: '＋', 0x58: 'Enter',
    0x62: '0', 0x63: '.', 0x82: 'Caps', 0x87: 'JP＼', 0x88: 'かな',
    0x89: 'JP¥', 0x8a: '変換', 0x8b: '無変換',
    0xcd: 'カーソル↑', 0xce: 'カーソル↓',
    0xcf: 'カーソル←', 0xd0: 'カーソル→',
    0xd1: '左クリック', 0xd2: '右クリック',
    0xd3: '中クリック', 0xd9: 'ホイール↑',
    0xda: 'ホイール↓', 0xdb: 'ホイール←',
    0xdc: 'ホイール→',
  };
  for (let i = 0; i < 26; i += 1) BASIC[0x04 + i] = String.fromCharCode(65 + i);
  '1234567890'.split('').forEach((c, i) => { BASIC[0x1e + i] = c; });
  for (let i = 0; i < 12; i += 1) BASIC[0x3a + i] = `F${i + 1}`;
  for (let i = 0; i < 9; i += 1) BASIC[0x59 + i] = String(i + 1);
  ['Ctrl', 'Shift', 'Alt', '⌘/Win', 'Ctrl', 'Shift', 'Alt', '⌘/Win']
    .forEach((n, i) => { BASIC[0xe0 + i] = n; });

  // A layer number is factual; its purpose depends on the user's own keymap.
  const LAYER_NAMES = Array.from({ length: MAX_LAYERS }, (_, index) => `Layer ${index}`);
  const BASIC_NOTE = {
    0x39: '英字の大文字固定を切り替える',
    0x82: '英字の大文字固定を切り替える（ロック式）',
    0x2a: '1文字消す',
    0x4c: 'カーソルの右を1文字消す',
  };

  function setStatus(message, tone = '') {
    status.textContent = message;
    if (tone) status.dataset.tone = tone;
    else delete status.dataset.tone;
  }

  function modName(bits) {
    const mods = ['Ctrl', 'Shift', 'Alt', '⌘/Win'];
    const selected = mods.filter((_, i) => bits & (1 << i));
    return `${bits & 0x10 ? '右' : ''}${selected.join('+') || '?'}`;
  }

  function customLabel(name) {
    if (/^ADV\d+$/.test(name)) {
      const id = name.slice(3);
      return [`${id}番に接続`, `登録済みの${id}番の機器へつなぎ直す`];
    }
    if (/^DEL\d+$/.test(name)) {
      const id = name.slice(3);
      return [`${id}番を削除`, `${id}番に登録した機器のペアリング情報を消す`];
    }
    return ({
      SEL_BLE: ['無線で出力', 'キー入力を無線（Bluetooth）で送る'],
      SEL_USB: ['USBで出力', 'キー入力をUSBケーブルで送る'],
      AD_WO_L: ['新規ペアリング', '新しい機器とのペアリングを始める'],
      DEL_ALL: ['全部を削除', '登録した機器のペアリング情報をすべて消す'],
      BATT: ['電池残量', '電池の残量を表示する'],
      ENT_SLP: ['スリープ', 'キーボードを深い休止状態にする'],
      DISABLE_KEY_OS_OVERRIDE: ['OS補正なし', 'JP/US配列の自動読み替えをやめる'],
      ENABLE_US_KEY_ON_JP_OS_OVERRIDE: ['US→JP補正', 'JP配列のOSでUS配列として打てるようにする'],
      ENABLE_JP_KEY_ON_US_OS_OVERRIDE: ['JP→US補正', 'US配列のOSでJP配列として打てるようにする'],
      ENABLE_WEB_BT_CONNECTION: ['Web BT 有効', 'ブラウザからの接続を許可する'],
      DISABLE_WEB_BT_CONNECTION: ['Web BT 無効', 'ブラウザからの接続を禁止する'],
    })[name] || [name, ''];
  }

  function keyInfo(keycode, custom) {
    const result = { m: '', hold: null, jump: null, note: '', q: false, raw: `0x${keycode.toString(16).padStart(4, '0')}` };
    const low = keycode & 0xff;
    const high = keycode >> 8;
    const basic = (code) => {
      if (!(code in BASIC)) result.q = true;
      if (code >= 0x54 && code <= 0x63) result.note = 'テンキー側の同じ記号';
      if (code in BASIC_NOTE) result.note = BASIC_NOTE[code];
      return BASIC[code] ?? `0x${code.toString(16).padStart(2, '0')}`;
    };
    if (keycode >= 0x7e00 && keycode <= 0x7eff) {
      const name = custom.get(keycode);
      if (name) [result.m, result.note] = customLabel(name);
      else { result.m = result.raw; result.q = true; }
    } else if (keycode <= 0xff) {
      result.m = basic(keycode);
    } else if (keycode >= 0x2000 && keycode <= 0x3fff) {
      result.m = basic(low);
      result.hold = { t: modName(high & 0x1f), kind: 'mod' };
    } else if (keycode >= 0x4000 && keycode <= 0x4fff) {
      const layer = high & 0x0f;
      result.m = basic(low);
      result.hold = { t: LAYER_NAMES[layer] || `L${layer}`, kind: 'layer', L: layer };
    } else if (keycode >= 0x0100 && keycode <= 0x1fff) {
      result.m = basic(low);
      result.note = `${modName(high & 0x1f)} を押しながらと同じ`;
    } else if (keycode >= 0x5200 && keycode <= 0x5207) {
      const layer = keycode - 0x5200;
      result.m = LAYER_NAMES[layer] || `L${layer}`;
      result.jump = layer;
    } else if (keycode >= 0x5220 && keycode <= 0x5227) {
      const layer = keycode - 0x5220;
      result.m = LAYER_NAMES[layer] || `L${layer}`;
      result.hold = { t: result.m, kind: 'layer', L: layer, only: true };
    } else {
      result.m = result.raw;
      result.q = true;
    }
    return result;
  }

  function parseKle(keymap) {
    const positions = [];
    let y = 0;
    keymap.forEach((line) => {
      let x = 0;
      line.forEach((item) => {
        if (typeof item === 'object') {
          x += Number(item.x || 0);
          y += Number(item.y || 0);
          return;
        }
        const parts = item.split('\n');
        if (parts.length > 9 && parts[9] === 'e') { x += 1; return; }
        const [row, col] = parts[0].split(',').map(Number);
        positions.push({ row, col, x, y });
        x += 1;
      });
      y += 1;
    });
    return positions;
  }

  function reportByteLength(report) {
    const bits = (report.items || []).reduce((total, item) => {
      return total + Number(item.reportSize || 0) * Number(item.reportCount || 0);
    }, 0);
    return Math.ceil(bits / 8);
  }

  function rawHidInterface(device) {
    const collections = [];
    const visit = (collection) => {
      collections.push(collection);
      (collection.children || []).forEach(visit);
    };
    (device.collections || []).forEach(visit);

    const raw = collections.find((collection) => {
      return Number(collection.usagePage) === 0xff60 && Number(collection.usage) === 0x61;
    });
    const outputCandidates = (raw ? raw.outputReports || [] : collections.flatMap((collection) => collection.outputReports || []));
    const inputCandidates = (raw ? raw.inputReports || [] : collections.flatMap((collection) => collection.inputReports || []));
    const output = outputCandidates.find((report) => reportByteLength(report) === REPORT_LENGTH)
      || outputCandidates.find((report) => reportByteLength(report) >= REPORT_LENGTH)
      || outputCandidates[0];
    const input = inputCandidates.find((report) => reportByteLength(report) === REPORT_LENGTH)
      || inputCandidates.find((report) => report.reportId === output?.reportId)
      || inputCandidates[0];
    if (!output) throw new Error('DRESSTHINGの通信用レポートを見つけられません。');
    return {
      outputReportId: Number(output.reportId || 0),
      outputLength: reportByteLength(output) || REPORT_LENGTH,
      inputReportId: input ? Number(input.reportId || 0) : null,
    };
  }

  function transfer(device, request, timeout = 2500) {
    const channel = rawHidInterface(device);
    const packet = new Uint8Array(channel.outputLength);
    packet.set(request.slice(0, channel.outputLength));
    return new Promise((resolve, reject) => {
      let timer;
      const clean = () => {
        clearTimeout(timer);
        device.removeEventListener('inputreport', onReport);
      };
      const onReport = (event) => {
        if (channel.inputReportId !== null && Number(event.reportId || 0) !== channel.inputReportId) return;
        clean();
        resolve(new Uint8Array(event.data.buffer.slice(event.data.byteOffset, event.data.byteOffset + event.data.byteLength)));
      };
      device.addEventListener('inputreport', onReport);
      timer = setTimeout(() => { clean(); reject(new Error('timeout')); }, timeout);
      device.sendReport(channel.outputReportId, packet).catch((error) => { clean(); reject(error); });
    });
  }

  async function readKeymap(device, configuration) {
    const definition = await fetch(configuration.file).then((response) => {
      if (!response.ok) throw new Error('配列データを読み込めません。');
      return response.json();
    });
    const rows = Number(definition.matrix.rows);
    const cols = Number(definition.matrix.cols);
    const layerResponse = await transfer(device, [0x11]);
    const availableLayers = layerResponse[0] === 0x11 ? layerResponse[1] : layerResponse[0];
    if (!availableLayers || availableLayers > 32) throw new Error('レイヤー数を読み取れません。');
    const readLayers = Math.min(availableLayers, MAX_LAYERS);
    const bytesNeeded = readLayers * rows * cols * 2;
    const bytes = new Uint8Array(bytesNeeded);
    for (let offset = 0; offset < bytesNeeded; offset += BUFFER_CHUNK) {
      const size = Math.min(BUFFER_CHUNK, bytesNeeded - offset);
      const response = await transfer(device, [0x12, offset >> 8, offset & 0xff, size]);
      if (response[0] !== 0x12) throw new Error('キーマップの応答を確認できません。');
      bytes.set(response.slice(4, 4 + size), offset);
    }
    const positions = parseKle(definition.layouts.keymap);
    const custom = new Map((definition.customKeycodes || []).map((item, i) => [0x7e00 + i, item.name]));
    const codeAt = (layer, row, col) => {
      const index = 2 * ((layer * rows + row) * cols + col);
      return (bytes[index] << 8) | bytes[index + 1];
    };
    const layers = [];
    for (let layer = 0; layer < readLayers; layer += 1) {
      layers.push(positions.map(({ row, col, x, y }) => ({ ...keyInfo(codeAt(layer, row, col), custom), x, y })));
    }
    const encoderLayers = [];
    let encoderReadable = true;
    for (let layer = 0; layer < readLayers; layer += 1) {
      try {
        const vialResponse = await transfer(device, [0xfe, 0x03, layer, 0]);
        if (vialResponse[0] !== 0xff) {
          const counterClockwise = (vialResponse[0] << 8) | vialResponse[1];
          const clockwise = (vialResponse[2] << 8) | vialResponse[3];
          encoderLayers.push([keyInfo(clockwise, custom), keyInfo(counterClockwise, custom)]);
          continue;
        }

        const counterClockwiseResponse = await transfer(device, [0x14, layer, 0, 0]);
        const clockwiseResponse = await transfer(device, [0x14, layer, 0, 1]);
        if (counterClockwiseResponse[0] !== 0x14 || clockwiseResponse[0] !== 0x14) {
          throw new Error('encoder-unavailable');
        }
        const counterClockwise = (counterClockwiseResponse[4] << 8) | counterClockwiseResponse[5];
        const clockwise = (clockwiseResponse[4] << 8) | clockwiseResponse[5];
        encoderLayers.push([keyInfo(clockwise, custom), keyInfo(counterClockwise, custom)]);
      } catch (_) {
        encoderReadable = false;
        encoderLayers.push([null, null]);
      }
    }
    return {
      name: configuration.board === 'twins' ? 'DRESSTHING Twins' : 'DRESSTHING',
      rows,
      cols,
      layers,
      enc: [...DATA[configuration.board].enc],
      encoders: encoderLayers,
      encoderReadable,
      routes: {},
      names: LAYER_NAMES.slice(0, readLayers),
      first10: [],
    };
  }

  async function connectAndRead() {
    if (!('hid' in navigator)) return;
    connectButton.disabled = true;
    setStatus('DRESSTHINGを選択してください…');
    let device;
    try {
      const selected = await navigator.hid.requestDevice({
        filters: Object.keys(DEVICES).map((id) => ({
          vendorId: VENDOR_ID,
          productId: Number(id),
          usagePage: 0xff60,
          usage: 0x61,
        })),
      });
      [device] = selected;
      if (!device) throw new DOMException('', 'NotFoundError');
      const configuration = DEVICES[device.productId];
      if (!configuration) throw new Error('対応するDRESSTHINGとして識別できません。');
      if (!device.opened) await device.open();
      setStatus('本体のキーマップを読み取っています…');
      const liveData = await readKeymap(device, configuration);
      DATA[configuration.board] = liveData;
      bi = names.indexOf(configuration.board);
      li = 0;
      boardsEl.hidden = true;
      [...tabsEl.children].forEach((button, index) => { button.hidden = index >= liveData.layers.length; });
      draw();
      sourceBadge.textContent = '接続中の本体';
      setStatus(`${liveData.name}の現在の設定を読み取りました。`, 'success');
    } catch (error) {
      if (error && error.name === 'NotFoundError') setStatus('接続はキャンセルされました。');
      else if (error && error.message === 'timeout') setStatus('DRESSTHINGから応答がありません。USB接続を確認して、もう一度お試しください。', 'error');
      else if (error?.name === 'NetworkError' || /write the report/i.test(error?.message || '')) setStatus('DRESSTHINGとの通信を開始できませんでした。USBケーブルを接続し直して、もう一度お試しください。', 'error');
      else setStatus(error?.message || '読み取りに失敗しました。', 'error');
    } finally {
      if (device?.opened) {
        try { await device.close(); } catch (_) { /* no-op */ }
      }
      connectButton.disabled = false;
    }
  }

  function xml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;',
    })[character]);
  }

  function short(value, max = 10) {
    const text = String(value ?? '');
    return text.length > max ? `${text.slice(0, max - 1)}…` : text;
  }

  function exportSvg(board) {
    const layers = board.layers.slice(0, MAX_LAYERS);
    const keyboardWidth = Math.max(...layers.flat().map((cell) => cell.x)) + 1;
    const keyboardHeight = Math.max(...layers.flat().map((cell) => cell.y)) + 1;
    const key = 44;
    const gap = 3;
    const panelGap = 22;
    const panelWidth = keyboardWidth * key + 36;
    const panelHeight = keyboardHeight * key + 76;
    const outer = 36;
    const top = 116;
    const columns = 2;
    const rows = Math.ceil(layers.length / columns);
    const width = Math.ceil(outer * 2 + panelWidth * columns + panelGap * (columns - 1));
    const height = Math.ceil(top + rows * panelHeight + panelGap * (rows - 1) + 46);
    const colors = ['#20251f', '#e34b4f', '#2f63d3', '#078a72', '#6e706c'];
    const layerNames = LAYER_NAMES;
    const compactLabels = {
      'カーソル↑': 'M↑',
      'カーソル↓': 'M↓',
      'カーソル←': 'M←',
      'カーソル→': 'M→',
      '左クリック': 'M1',
      '右クリック': 'M2',
      '中クリック': 'M3',
      'ホイール↑': 'W↑',
      'ホイール↓': 'W↓',
      'ホイール←': 'W←',
      'ホイール→': 'W→',
      '右Shift': 'RShift',
      '無線で出力': '無線出力',
      'USBで出力': 'USB出力',
      '新規ペアリング': 'ペアリング',
      '0番に接続': '接続 0',
      '1番に接続': '接続 1',
      '2番に接続': '接続 2',
      '全部を削除': '全削除',
    };
    const encoderAssignments = (layerIndex) => {
      if (board.encoderReadable === false) return { clockwise: '?', counterClockwise: '?' };
      let turns = board.encoders?.[layerIndex];
      let source = layerIndex;
      while (turns?.[0]?.raw === '0x0001' && source > 0) {
        source -= 1;
        turns = board.encoders?.[source];
      }
      const turn = (info) => {
        if (!info || info.raw === '0x0000') return '—';
        if (info.jump !== null) return `L${info.jump}`;
        if (info.hold?.only) return `L${info.hold.L}`;
        return compactLabels[info.m] || info.m || '—';
      };
      return {
        clockwise: turn(turns?.[0]),
        counterClockwise: turn(turns?.[1]),
      };
    };

    const panels = layers.map((cells, layerIndex) => {
      const isLastOddPanel = layers.length % columns === 1 && layerIndex === layers.length - 1;
      const panelX = isLastOddPanel
        ? (width - panelWidth) / 2
        : outer + (layerIndex % columns) * (panelWidth + panelGap);
      const panelY = top + Math.floor(layerIndex / columns) * (panelHeight + panelGap);
      const accent = colors[layerIndex];
      const dial = encoderAssignments(layerIndex);
      const cellSvg = cells.map((cell, cellIndex) => {
        const x = panelX + 18 + cell.x * key;
        const y = panelY + 46 + cell.y * key;
        const isEncoder = board.enc.includes(cellIndex);
        const baseLabel = compactLabels[cell.m] || cell.m;
        const label = cell.jump !== null ? `L${cell.jump}` : (cell.hold?.only ? `L${cell.hold.L}` : baseLabel);
        const hold = isEncoder || !cell.hold || cell.hold.only
          ? ''
          : (cell.hold.kind === 'layer' ? `L${cell.hold.L}` : (compactLabels[cell.hold.t] || cell.hold.t));
        const empty = !isEncoder && cell.raw === '0x0000';
        const transparent = cell.raw === '0x0001';
        const displayLabel = empty || transparent ? '' : short(label, 9);
        const holdFill = cell.hold?.kind === 'layer' && colors[cell.hold.L] ? colors[cell.hold.L] : colors[0];
        const holdWidth = hold ? Math.min(35, Math.max(20, 10 + String(hold).length * 4.2)) : 0;
        if (isEncoder) {
          const left = short(dial.counterClockwise, 5);
          const right = short(dial.clockwise, 5);
          const encoderFont = (value) => String(value).length > 4 ? 6 : String(value).length > 2 ? 7.5 : 10.5;
          return `<g transform="translate(${x} ${y})">
            <rect width="${key - gap}" height="${key - gap}" rx="${(key - gap) / 2}" fill="#f7f6f2" stroke="#20251f" stroke-width="1"/>
            <line x1="${(key - gap) / 2}" y1="7" x2="${(key - gap) / 2}" y2="34" stroke="#e5e4e0" stroke-width=".7"/>
            <text x="${(key - gap) * .25}" y="${(key - gap) / 2}" text-anchor="middle" dominant-baseline="central" font-size="${encoderFont(left)}" font-weight="700" fill="${accent}">${xml(left)}</text>
            <text x="${(key - gap) * .75}" y="${(key - gap) / 2}" text-anchor="middle" dominant-baseline="central" font-size="${encoderFont(right)}" font-weight="700" fill="${accent}">${xml(right)}</text>
          </g>`;
        }
        return `<g transform="translate(${x} ${y})">
          <rect width="${key - gap}" height="${key - gap}" rx="5" fill="${hold ? '#f1efe8' : '#f7f6f2'}" stroke="#cbc9c2" stroke-width="1"/>
          <text x="${(key - gap) / 2}" y="${hold ? 14 : (key - gap) / 2}" text-anchor="middle" dominant-baseline="central" font-size="${displayLabel.length > 7 ? 5.5 : displayLabel.length > 4 ? 6.5 : displayLabel.length > 3 ? 8 : 10.5}" font-weight="700" fill="${accent}">${xml(displayLabel)}</text>
          ${hold ? `<rect x="${((key - gap) - holdWidth) / 2}" y="27" width="${holdWidth}" height="11" rx="5.5" fill="${holdFill}"/><text x="${(key - gap) / 2}" y="32.8" text-anchor="middle" dominant-baseline="central" font-size="5.8" font-weight="700" fill="#fff">${xml(short(hold, 9))}</text>` : ''}
        </g>`;
      }).join('');
      return `<g>
        <rect x="${panelX}" y="${panelY}" width="${panelWidth}" height="${panelHeight}" rx="15" fill="#fff" stroke="#e5e4e0"/>
        <circle cx="${panelX + 20}" cy="${panelY + 23}" r="10" fill="${accent}"/>
        <text x="${panelX + 20}" y="${panelY + 26.5}" text-anchor="middle" font-size="8.5" font-weight="700" fill="#fff">L${layerIndex}</text>
        <text x="${panelX + 38}" y="${panelY + 28}" font-size="14" font-weight="700" fill="#1c231e">${xml(layerNames[layerIndex])}</text>
        ${cellSvg}
      </g>`;
    }).join('');

    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="100%" height="100%" fill="#fff"/>
      <style>text{font-family:-apple-system,BlinkMacSystemFont,'Hiragino Sans','Noto Sans JP',sans-serif}</style>
      <text x="${outer}" y="38" font-size="11" font-weight="700" letter-spacing="-.3" fill="#20251f">imDRESSion</text>
      <text x="${outer}" y="78" style="font-family:'Hiragino Mincho ProN','Yu Mincho','Noto Serif JP',serif" font-size="28" font-weight="600" fill="#20251f">${xml(board.name)}</text>
      <text x="${width - outer}" y="38" text-anchor="end" font-size="8.5" font-weight="700" letter-spacing="1.6" fill="#6e706c">LAYER MAPS · L0—L${layers.length - 1}</text>
      <text x="${width - outer}" y="76" text-anchor="end" font-size="9.5" fill="#6e706c">カプセル：長押し時</text>
      ${panels}
      <text x="${outer}" y="${height - 17}" font-size="8.5" fill="#9a9c97">表示内容は、本体から読み取ったキー割り当てです。</text>
      <text x="${width - outer}" y="${height - 17}" text-anchor="end" font-size="8" letter-spacing="1.2" fill="#9a9c97">DRESS THE SELF.</text>
    </svg>`;
  }

  function exportCompositeSvg(board) {
    const layers = board.layers.slice(0, COMPOSITE_LAYER_COUNT);
    const positions = layers[0];
    const keyboardWidth = Math.max(...positions.map((cell) => cell.x)) + 1;
    const key = 104;
    const keyBox = 96;
    const outer = 80;
    const top = 176;
    const width = Math.max(1200, Math.ceil(outer * 2 + keyboardWidth * key));
    const keyboardBottom = top + Math.max(...positions.map((cell) => cell.y)) * key + keyBox;
    const ruleY = keyboardBottom + 22;
    const height = ruleY + 226;
    const colors = ['#20251f', '#e34b4f', '#2f63d3', '#078a72', '#6e706c'];
    const compactLabels = {
      'カーソル↑': 'M↑',
      'カーソル↓': 'M↓',
      'カーソル←': 'M←',
      'カーソル→': 'M→',
      '左クリック': 'M1',
      '右クリック': 'M2',
      '中クリック': 'M3',
      'ホイール↑': 'W↑',
      'ホイール↓': 'W↓',
      'ホイール←': 'W←',
      'ホイール→': 'W→',
      '右Shift': 'RShift',
      '無線で出力': '無線出力',
      'USBで出力': 'USB出力',
      '新規ペアリング': 'ペアリング',
      '0番に接続': '接続 0',
      '1番に接続': '接続 1',
      '2番に接続': '接続 2',
      '全部を削除': '全削除',
    };
    const assignment = (cell) => {
      if (!cell || cell.raw === '0x0000' || cell.raw === '0x0001' || cell.m === '▽') return '';
      if (cell.jump !== null) return `L${cell.jump}`;
      if (cell.hold?.only) return `L${cell.hold.L}`;
      return compactLabels[cell.m] || cell.m || '';
    };
    const labelFontSize = (label, main = false) => {
      const length = String(label || '').length;
      if (main) return length > 8 ? 9 : length > 5 ? 11 : length > 3 ? 13 : 16;
      return length > 8 ? 8.5 : length > 5 ? 10 : length > 3 ? 12.5 : 16;
    };
    const holdBadge = (cell, x, y) => {
      if (!cell?.hold || cell.hold.only) return '';
      const label = cell.hold.kind === 'layer'
        ? `L${cell.hold.L}`
        : (compactLabels[cell.hold.t] || cell.hold.t || '');
      if (!label) return '';
      const fill = cell.hold.kind === 'layer' && colors[cell.hold.L]
        ? colors[cell.hold.L]
        : colors[0];
      const badgeWidth = Math.min(82, Math.max(46, 25 + String(label).length * 8));
      const badgeX = x + (keyBox - badgeWidth) / 2;
      return `<g>
        <rect x="${badgeX}" y="${y + 63}" width="${badgeWidth}" height="26" rx="13" fill="${fill}"/>
        <text x="${x + keyBox / 2}" y="${y + 77}" text-anchor="middle" dominant-baseline="middle" font-size="${labelFontSize(label)}" font-weight="700" letter-spacing="-.2" fill="#fff">${xml(label)}</text>
      </g>`;
    };
    const encoderAssignment = (info) => {
      if (!info || info.raw === '0x0000' || info.raw === '0x0001') return '';
      if (info.jump !== null) return `L${info.jump}`;
      if (info.hold?.only) return `L${info.hold.L}`;
      return compactLabels[info.m] || info.m || '';
    };
    const encoderSvg = (x, y) => {
      const layerRows = layers.map((_, layerIndex) => {
        const encoder = board.encoders?.[layerIndex];
        const clockwise = board.encoderReadable === false ? '?' : encoderAssignment(encoder?.[0]);
        const counterClockwise = board.encoderReadable === false ? '?' : encoderAssignment(encoder?.[1]);
        if (!clockwise && !counterClockwise) return '';
        const labelY = y + 25 + layerIndex * 12;
        const rowFont = Math.max(String(clockwise).length, String(counterClockwise).length) > 4 ? 6.8 : 9.5;
        return `<g font-size="${rowFont}" font-weight="700" fill="${colors[layerIndex]}">
          ${counterClockwise ? `<text x="${x + 34}" y="${labelY}" text-anchor="middle" dominant-baseline="middle">${xml(short(counterClockwise, 7))}</text>` : ''}
          ${clockwise ? `<text x="${x + 62}" y="${labelY}" text-anchor="middle" dominant-baseline="middle">${xml(short(clockwise, 7))}</text>` : ''}
        </g>`;
      }).join('');
      return `<g>
        <rect x="${x}" y="${y}" width="${keyBox}" height="${keyBox}" rx="48" fill="#f7f6f2" stroke="#20251f"/>
        <line x1="${x + keyBox / 2}" y1="${y + 11}" x2="${x + keyBox / 2}" y2="${y + 85}" stroke="#e5e4e0"/>
        ${layerRows}
      </g>`;
    };
    const cells = positions.map((position, cellIndex) => {
      const x = outer + position.x * key;
      const y = top + position.y * key;
      const isEncoder = board.enc.includes(cellIndex);
      if (isEncoder) return encoderSvg(x, y);
      const labels = layers.map((layer) => assignment(layer[cellIndex]));
      const hasHold = Boolean(layers[0]?.[cellIndex]?.hold && !layers[0][cellIndex].hold.only);
      const mainY = y + (hasHold ? 38 : 48);
      const lowerLabelY = y + (hasHold ? 52 : 74);
      const keyFill = hasHold ? '#f1efe8' : '#f7f6f2';
      return `<g>
        <rect x="${x}" y="${y}" width="${keyBox}" height="${keyBox}" rx="9" fill="${keyFill}" stroke="#cbc9c2"/>
        ${labels[0] ? `<text x="${x + 48}" y="${mainY}" text-anchor="middle" dominant-baseline="middle" font-size="${labelFontSize(labels[0], true)}" font-weight="700" letter-spacing="-.2" fill="${colors[0]}">${xml(short(labels[0], 12))}</text>` : ''}
        ${labels[4] ? `<text x="${x + 12}" y="${y + 24}" text-anchor="start" dominant-baseline="middle" font-size="${labelFontSize(labels[4])}" font-weight="700" letter-spacing="-.2" fill="${colors[4]}">${xml(short(labels[4], 10))}</text>` : ''}
        ${labels[1] ? `<text x="${x + 84}" y="${y + 24}" text-anchor="end" dominant-baseline="middle" font-size="${labelFontSize(labels[1])}" font-weight="700" letter-spacing="-.2" fill="${colors[1]}">${xml(short(labels[1], 10))}</text>` : ''}
        ${labels[2] ? `<text x="${x + 82}" y="${lowerLabelY}" text-anchor="end" dominant-baseline="middle" font-size="${labelFontSize(labels[2])}" font-weight="700" letter-spacing="-.2" fill="${colors[2]}">${xml(short(labels[2], 10))}</text>` : ''}
        ${labels[3] ? `<text x="${x + 14}" y="${lowerLabelY}" text-anchor="start" dominant-baseline="middle" font-size="${labelFontSize(labels[3])}" font-weight="700" letter-spacing="-.2" fill="${colors[3]}">${xml(short(labels[3], 10))}</text>` : ''}
        ${holdBadge(layers[0]?.[cellIndex], x, y)}
      </g>`;
    }).join('');
    const legendY = ruleY + 28;
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="100%" height="100%" fill="#fff"/>
      <g font-family="-apple-system,BlinkMacSystemFont,'Hiragino Sans','Noto Sans JP',sans-serif">
      <text x="${outer}" y="58" dominant-baseline="middle" font-size="18" font-weight="700" letter-spacing="-.5" fill="#20251f">imDRESSion</text>
      <text x="${width - outer}" y="58" text-anchor="end" dominant-baseline="middle" font-size="12" font-weight="700" letter-spacing="2.2" fill="#6e706c">DRESSTHING / KEYMAP</text>
      <text x="${outer}" y="112" dominant-baseline="middle" font-family="'Hiragino Mincho ProN','Yu Mincho','Noto Serif JP',serif" font-size="36" font-weight="600" fill="#20251f">${xml(board.name)}</text>
      <text x="${outer}" y="150" dominant-baseline="middle" font-size="14" letter-spacing="1.2" fill="#6e706c">LAYER MAP · L0—L4</text>
      ${cells}
      <line x1="${outer}" y1="${ruleY}" x2="${width - outer}" y2="${ruleY}" stroke="#e5e4e0"/>
      <g transform="translate(${outer} ${legendY})">
        <rect width="76" height="76" rx="9" fill="#f7f6f2" stroke="#cbc9c2"/>
        <text x="38" y="38" text-anchor="middle" dominant-baseline="middle" font-size="16" font-weight="700" fill="${colors[0]}">L0</text>
        <text x="10" y="15" dominant-baseline="middle" font-size="16" font-weight="700" fill="${colors[4]}">L4</text>
        <text x="66" y="15" text-anchor="end" dominant-baseline="middle" font-size="16" font-weight="700" fill="${colors[1]}">L1</text>
        <text x="66" y="63" text-anchor="end" dominant-baseline="middle" font-size="16" font-weight="700" fill="${colors[2]}">L2</text>
        <text x="10" y="63" dominant-baseline="middle" font-size="16" font-weight="700" fill="${colors[3]}">L3</text>
      </g>
      <text x="${outer + 102}" y="${legendY + 24}" dominant-baseline="middle" font-size="15" font-weight="700" fill="#20251f">位置と色でレイヤーを見分けます</text>
      <text x="${outer + 102}" y="${legendY + 54}" dominant-baseline="middle" font-size="15" font-weight="600" fill="#6e706c">白抜きバッジは、長押ししたときの動作です</text>
      <line x1="${outer}" y1="${ruleY + 126}" x2="${width - outer}" y2="${ruleY + 126}" stroke="#e5e4e0"/>
      <text x="${outer}" y="${ruleY + 160}" dominant-baseline="middle" font-size="14" font-weight="600" fill="#6e706c">M＋矢印＝マウス移動　・　M1 / M2＝左 / 右クリック　・　W＋矢印＝ホイール</text>
      <text x="${outer}" y="${ruleY + 190}" dominant-baseline="middle" font-size="14" font-weight="600" fill="#6e706c">ダイヤル：左側＝左回転 / 右側＝右回転　・　空欄＝割り当てなし</text>
      <text x="${width - outer}" y="${height - 14}" text-anchor="end" dominant-baseline="middle" font-size="11" letter-spacing="1.4" fill="#9a9c97">DRESS THE SELF.</text>
      </g>
    </svg>`;
  }

  function currentExport() {
    return { svg: exportSvg(DATA[names[bi]]), filename: `dressthing-keymap-${names[bi].replace(/\s*\/\s*|\s+/g, '-')}` };
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = doc.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    doc.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function saveSvg() {
    const { svg, filename } = currentExport();
    downloadBlob(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }), `${filename}.svg`);
  }

  function savePng() {
    const { svg, filename } = currentExport();
    downloadPng(svg, filename);
  }

  function saveCompositePng() {
    const boardName = names[bi];
    downloadPng(exportCompositeSvg(DATA[boardName]), `dressthing-keymap-${boardName.replace(/\s*\/\s*|\s+/g, '-')}-composite`);
  }

  function saveCompositeSvg() {
    const boardName = names[bi];
    const filename = `dressthing-keymap-${boardName.replace(/\s*\/\s*|\s+/g, '-')}-composite`;
    downloadBlob(new Blob([exportCompositeSvg(DATA[boardName])], { type: 'image/svg+xml;charset=utf-8' }), `${filename}.svg`);
  }

  function downloadPng(svg, filename) {
    const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => {
      const canvas = doc.createElement('canvas');
      canvas.width = image.naturalWidth * 2;
      canvas.height = image.naturalHeight * 2;
      const context = canvas.getContext('2d');
      context.scale(2, 2);
      context.drawImage(image, 0, 0);
      URL.revokeObjectURL(url);
      canvas.toBlob((png) => {
        if (png) downloadBlob(png, `${filename}.png`);
      }, 'image/png');
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      setStatus('PNGの作成に失敗しました。SVGのダウンロードをお試しください。', 'error');
    };
    image.src = url;
  }

  if ('hid' in navigator) {
    supportNote.textContent = 'DRESSTHINGをUSB接続し、ボタンを押して本体を選択します。';
    connectButton.addEventListener('click', connectAndRead);
  } else {
    connectButton.disabled = true;
    supportNote.textContent = '本体からの読み取りは、ChromeまたはEdgeのデスクトップ版でご利用ください。';
  }
  savePngButton.addEventListener('click', savePng);
  saveCompositePngButton.addEventListener('click', saveCompositePng);
    } catch (error) {
      const status = root.getElementById('status');
      if (status) { status.textContent = error && error.message ? error.message : 'ツールを読み込めませんでした。'; status.dataset.tone = 'error'; }
      const button = root.getElementById('connectButton');
      if (button) button.disabled = true;
    }
  }
}

if (!customElements.get('dressthing-keymap-tool')) customElements.define('dressthing-keymap-tool', DressthingKeymapTool);
